<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>

    <!-- 共通モーダル -->
    <Modal></Modal>

    <!-- 画面ローダー -->
    <Loader></Loader>
  </v-app>
</template>


<script>
import Modal from '/src/views/components/utility/Modal.vue'
import Loader from "../utility/Loader";

export default {
  components: {
    Modal,
    Loader
  },
}
</script>